/**
 * Returns a list with auxiliaries for the Portuguese passive voice assessment.
 * @returns {Array} The list with auxiliaries.
 */
export default [
	"sou",
	"és",
	"é",
	"somos",
	"sois",
	"são",
	"era",
	"eras",
	"era",
	"éramos",
	"éreis",
	"eram",
	"serei",
	"serás",
	"será",
	"seremos",
	"sereis",
	"serão",
	"sido",
	"foste",
	"foi",
	"fomos",
	"fostes",
	"fora",
	"foras",
	"fôramos",
	"fôreis",
	"foram",
	"seja",
	"sejas",
	"seja",
	"sejamos",
	"sejais",
	"sejam",
	"fui",
	"fosse",
	"fosses",
	"fosse",
	"fôssemos",
	"fôsseis",
	"fossem",
	"for",
	"fores",
	"for",
	"formos",
	"fordes",
	"forem",
	"seria",
	"serias",
	"seria",
	"seríamos",
	"seríeis",
	"seriam",
	"ser",
	"seres",
	"ser",
	"sermos",
	"serdes",
	"serem",
];

